import { render, staticRenderFns } from "./ProductOption.vue?vue&type=template&id=88a057d8&"
import script from "./ProductOption.vue?vue&type=script&lang=js&"
export * from "./ProductOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports